import React, { useEffect, useState } from "react";
import bgImage from "./contactus/Contactushero.jpg";

const Hero = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger animations only once on page load
    setVisible(true);
  }, []);

  return (
    <section
      className="relative min-h-screen bg-cover bg-center flex items-center justify-start px-6 md:px-16"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <style>{`
        @keyframes fadeSlideUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-up {
          opacity: 0;
          animation: fadeSlideUp 0.8s ease-out forwards;
        }
      `}</style>

      {/* Overlay */}
      <div
        className="absolute top-0 left-0 w-full h-full z-[2] pointer-events-none"
        style={{
          background: `linear-gradient(
            to bottom,
            rgba(2, 4, 79, 0.85) 0%,
            rgba(2, 4, 79, 0.65) 25%,
            rgba(134, 205, 233, 0.85) 90%,
            rgba(134, 205, 233, 1) 100%
          )`
        }}
      />


      {/* Content */}
      <div className="relative z-10 max-w-2xl text-left">
        <h1
          className={`text-white font-bold text-[38px] sm:text-[48px] md:text-[60px] lg:text-[70px] leading-tight font-satoshi mb-4 ${
            visible ? "animate-fade-up" : ""
          }`}
          style={{ animationDelay: "0s", animationFillMode: "forwards" }}
        >
          Connect With Your <br />
          <span className="text-[#00B2FF]">Big Blue Partner</span>
        </h1>

        <p
          className={`text-white text-[15px] sm:text-[16px] md:text-[18px] lg:text-[20px] font-inter leading-relaxed max-w-xl ${
            visible ? "animate-fade-up" : ""
          }`}
          style={{ animationDelay: "0.5s", animationFillMode: "forwards" }}
        >
          Have a question, a shipment or a challenge to solve? Let{" "}
          <strong className="font-semibold">Big Blue</strong> handle your
          worries related to logistics. From the first mile to the final
          delivery, we’re here to connect.
        </p>
      </div>
    </section>
  );
};

export default Hero;
